import { Formatters } from '../modules'

export default {
  props: {
    name: { label: '品名', required: true },
    proposed_price: {
      label: '参考价格',
      required: true,
      default: 0,
      type: 'number',
      formatter: Formatters.money,
      classes: 'right aligned hide-in-tablet',
      min: 0,
      controls: false,
    },
    quantity: {
      label: '库存',
      required: true,
      default: 0,
      type: 'number',
      classes: 'right aligned',
      min: 0,
      controls: true,
    },
    used_quantity: {
      label: '已用',
      disabled: true,
      classes: 'right aligned',
    },
    rest_quantity: {
      label: '剩余',
      disabled: true,
      classes: 'right aligned',
      formatter: (_, record) => record.quantity - record.used_quantity,
    },
    name_category: {
      label: '品名',
      formatter: (_, record) => (record.category ? `${record.name} - ${record.category}` : record.name),
    },
    category: { label: '品类' },
    variant: { label: '颜色' },
    variant_select: {
      label: '颜色',
      model: 'variant',
      type: (_, record) => ((record.variant || []).length ? 'select' : 'normal'),
      formatter: (_, record) => record.variant,
      select: (_, record) => (record.variants || []).map(i => ({ key: i, label: i })),
    },
    variants: {
      label: '全部颜色',
      note: '(用逗号分隔)',
      classes: 'hide-in-mobile',
      maxlength: 20,
      tooltip: 'top center',
      type: 'virtual',
      formatter: (value) => ((value || []).join(',')),
      setter: (value, record) => {
        /* eslint-disable no-param-reassign */
        record.variants = (value || '')
          .trim().replace(/，/g, ',')
          .split(',')
          .map(i => i.trim())
          .filter(i => i)
      },
    },
    note: {
      label: '备注',
      maxlength: 15,
      tooltip: 'top center',
      classes: 'hide-in-mobile',
    },
    note_input: {
      label: '备注',
      model: 'note',
      type: 'input',
      classes: 'hide-in-tablet',
    },
  },
  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
    },
    moveright: {
      icon: 'angle double right',
      tooltip: '移到右边',
    },
    moveleft: {
      icon: 'angle double left',
      tooltip: '移到左边',
    },
    add: {
      icon: 'add',
      tooltip: '增加',
    },
    minus: {
      icon: 'minus',
      tooltip: '减少',
    },
    remove: {
      icon: 'remove',
      tooltip: '移除',
      classes: 'hide-in-mobile',
    },
  },
  layouts: {
    default: {
      layout: ['name', 'category', 'variants', 'proposed_price', 'quantity', 'used_quantity', 'rest_quantity', 'note'],
    },
    room: {
      layout: ['name_category', 'variant', 'proposed_price', 'quantity', 'note'],
    },
    editing: {
      form: true,
      layout: ['name_category', 'variant_select', 'proposed_price', 'quantity', 'note_input'],
    },
    detail: {
      layout: ['name', 'category', 'variants', 'proposed_price', 'quantity', 'note'],
    },
  },
  form: {
    create: {
      type: 'post',
      url: 'properties',
      confirm: undefined,
      loadOnSuccess: 'properties',
    },
    modify: {
      type: 'put',
      url() { return `properties/${this.form._id}` },
      confirm: undefined,
      loadOnSuccess: 'properties',
    },
    layout: [
      ['name', 'category', 'variants'],
      ['proposed_price', 'quantity', 'note'],
    ],
  },

  filters: {
    search: {
      type: 'search',
      keys: [
        'name',
        'category',
        'variants',
      ],
    },
    select: {
      type: 'select',
      selects: [{
        name: null,
        label: '全部',
      },
      {
        name: 'incomplete',
        label: '信息不全',
        filter: (record) => {
          if (!record.name)
            return true
          if (!record.proposed_price)
            return true
          return false
        },
      },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/property.js